import { Portal } from "@angular/cdk/portal";
import { Injectable } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AdvisorBarLayoutService {
  private advisorPortalSource = new BehaviorSubject<Portal<any> | null>(null);
  private advisorClassSource = new BehaviorSubject<string | null>(null);

  // Il contenuto
  advisorPortal = this.advisorPortalSource.asObservable();

  // Boolean per sapere se la barra deve esistere
  hasAdvisorContent = this.advisorPortal.pipe(map(portal => !!portal));
  // "!!portal": verifica se è o meno valorizzato "portal" e forzo la risposta a boolean

  // Classe CSS opzionale da applicare all'advisor-bar (es. 'map-mode')
  advisorClass = this.advisorClassSource.asObservable();

  setAdvisor(portal: Portal<any> | null) {
    this.advisorPortalSource.next(portal);
  }

  setAdvisorClass(className: string | null) {
    this.advisorClassSource.next(className);
  }
}

/*
Esempio di utilizzo in una pagina:
  html:
    <ng-template #advisorContent>
      <div><h3>Advisor test!</h3></div>
    </ng-template>

  ts:
    @ViewChild('advisorContent') advisorContent!: TemplateRef<any>;
    constructor(
      private advisorBarLayoutService: AdvisorBarLayoutService, 
      private viewContainerRef: ViewContainerRef
    ) { .. }
    ngAfterViewInit() { // Popolo l'advisor bar
      // TIP: il "promise" è usato per evitare errori(NG0100) in console per ciclo di vita di angular
      Promise.resolve().then(() => { 
        const portal = new TemplatePortal(this.advisorContent, this.viewContainerRef);
        this.advisorBarLayoutService.setAdvisor(portal);
      });
    }
    ngOnDestroy() { // Svuoto l'advisor bar
      this.advisorBarLayoutService.setAdvisor(null);
    }
*/